var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.canCreateContent())?_c('v-btn',{staticClass:"elevation-0",attrs:{"round":"","outline":"","color":"success","e2e-id":"new_content"},on:{"click":_vm.openNewContentDialog}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-plus")]),_vm._v("New Content ")],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }